import { Pipe, PipeTransform } from '@angular/core';
import { Country } from '../../models/dtos/responses/country/country';

@Pipe({
  name: 'flag',
})
/**
 * Flag pipe takes a string and returns a flag
 */
export class FlagPipe implements PipeTransform {
  /**
   * Flag icon css class from Country object or string
   * @param {Country | string } value
   * @return {string}
   */
  transform(value: Country | string): string {
    const prefix = 'fi fi-';

    let countryCode = '';

    if (typeof value === 'string') {
      countryCode = value.toLowerCase();
    } else {
      countryCode = value.initials.toLowerCase();
    }

    return `${prefix}${countryCode}`;
  }
}
